import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AppConfigService } from 'src/app/services/app.config.service';
import { I18Service } from 'src/app/services/i18.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CanvasData, WhiteboardComponent } from './whiteboard.component';

@Component({
  selector: 'app-whiteboard-popup',
  templateUrl: './whiteboard-popup.component.html',
  styleUrls: ['./whiteboard-popup.component.scss']
})
export class WhiteboardPopupComponent {
  @Input() canvasData?: CanvasData;
  // @Input() zoom = true;
  // @Input() readonly = AppConfigService.role == PartecipantRoles.SecondaryClient || this.config.AS?.whiteboardSharedEnabled;

  @Output() close = new EventEmitter<boolean>();
  @Output() opened = new EventEmitter<boolean>();

  @ViewChild(WhiteboardComponent) whiteboardComponent?: WhiteboardComponent;

  closedExternally = false;
  constructor(public config: AppConfigService) {}

  onWhiteboardClose(): void {
    this.close.emit(true);
  }

  onWhiteboardOpened(): void {
    this.opened.emit(true);
  }

  async onPanelClose(): Promise<void> {
    // Verifica se ci sono modifiche non salvate
    if (this.config.whiteboardHasUnsavedChanges && !this.config.whiteboardReadonly) {
      const result = await NotificationService.popupWarn({
        msg: I18Service.get('Whiteboard.UnsavedChanges'),
        title: I18Service.get('Whiteboard.CloseConfirmTitle'),
        confirmButton: I18Service.get('Whiteboard.CloseWithoutSaving'),
        cancelButton: I18Service.get('POPUP.CANCEL')
      });

      // Se l'utente annulla, non chiudere
      if (result.isDismissed) {
        return;
      }
    }

    // Procedi con la chiusura
    this.closedExternally = true;
    setTimeout(() => {
      this.close.emit(true);
    });
  }
  
  onPanelInitialized(): void {
    // Forza un resize della whiteboard quando il pannello è inizializzato
    // setTimeout(() => {
    //   if (this.whiteboardComponent) {
    //     this.whiteboardComponent.forceResize();
    //   }
    // }, 100);
  }
  
  get title(): string {
    let title = I18Service.get('Whiteboard.EditTitle');
    if (this.config.whiteboardReadonly){
      title = I18Service.get('Whiteboard.Title');
      const who = this.config.whiteboardFromWho;
      if (who) {
        const partecipant = this.config.partecipantIds.find(p => p.partecipantId == who)
        title += ' ' + I18Service.roleAndAlias(partecipant);
      }
  }
    return title;
  }
}
